import { render, staticRenderFns } from "./FormDigitalSeo.vue?vue&type=template&id=70b84fd2&scoped=true&lang=pug&"
import script from "./FormDigitalSeo.vue?vue&type=script&lang=js&"
export * from "./FormDigitalSeo.vue?vue&type=script&lang=js&"
import style0 from "./FormDigitalSeo.vue?vue&type=style&index=0&id=70b84fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b84fd2",
  null
  
)

export default component.exports